import { tableOptionsToFirstPage } from '@/store/modules/StateUtil';


export const defectReportIndexState = {
    namespaced: true,
    state: {
        dateRange: {
            startDate: null,
            endDate: null,
        },
        filterText: null,
        filterDevice: null,
        filterReporterUser: null,
        filterStatusChoices: {
            statusNEW: true,
            statusOPEN: true,
            statusFIXED: true,
            statusINVALID: true,
        },
        tableOptions: {
            page: 1,
            itemsPerPage: 30,
            sortBy: ['created'],
            sortDesc: [true],
            mustSort: true,
            multiSort: false,
        },
    },
    mutations: {
        setDateRange(state, dateRange) {
            state.dateRange = dateRange;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setOnlyCurrentUserAssigned(state, onlyCurrentUserAssigned) {
            state.onlyCurrentUserAssigned = onlyCurrentUserAssigned;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterText(state, filterText) {
            state.filterText = filterText;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterDevice(state, filterDevice) {
            state.filterDevice = filterDevice;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterReporterUser(state, filterReporterUser) {
            state.filterReporterUser = filterReporterUser;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterStatusChoices(state, filterStatusChoices) {
            state.filterStatusChoices = filterStatusChoices;
            state.tableOptions = tableOptionsToFirstPage(state);
        },

        setTableOptions(state, tableOptions) {
            state.tableOptions = tableOptions;
        },
    },
    getters: {
        dateRange: state => {
            return state.dateRange;
        },
        filterText: state => {
            return state.filterText;
        },
        filterDevice: state => {
            return state.filterDevice;
        },
        filterReporterUser: state =>{
            return state.filterReporterUser;
        },
        filterStatusChoices: state =>{
            return state.filterStatusChoices;
        },
        tableOptions: state => {
            return state.tableOptions;
        },
    },
};
